import ExistingAssetTable from './ExistingAssetTable';

export default ExistingAssetTable;
